let AbstractTextEditor = class {};
class FakeAbstractTextEditor {
  static [Symbol.hasInstance](instance) {
      return AbstractTextEditor != null && instance instanceof AbstractTextEditor
  }
}
function setAbstractTextEditor(_AbstractTextEditor) {
  AbstractTextEditor = _AbstractTextEditor;
}
export { FakeAbstractTextEditor as AbstractTextEditor, setAbstractTextEditor };
